import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section id="about" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
          <div className="flex-1">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4 whitespace-nowrap">
              Pandabuy Guide
            </span>
            <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 leading-tight mb-6">
              Why Use<br />pandabuyspreadsheet<br />in 2026?
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4 max-w-lg">
              <strong>pandabuyspreadsheet</strong> is a curated system that helps users quickly discover high-quality product listings through organized spreadsheets. Instead of searching endlessly, users can access structured lists with pricing, quality ratings, and comparisons.
            </p>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-lg">
              We simplify discovery, comparison, and decision-making. Every spreadsheet is verified, updated weekly, and organized by category so you spend less time hunting and more time finding exactly what you want.
            </p>
          </div>

          <div className="flex-1">
            <div className="bg-accent-500 rounded-2xl p-8 md:p-10 relative overflow-hidden">
              <div className="absolute top-6 right-6 flex gap-1.5">
                <span className="w-1.5 h-1.5 rounded-full bg-white/30"></span>
                <span className="w-1.5 h-1.5 rounded-full bg-white/30"></span>
                <span className="w-1.5 h-1.5 rounded-full bg-white/30"></span>
              </div>
              <span className="text-white/50 text-xs uppercase tracking-wider mb-6 block">Editor&apos;s Pick</span>
              <blockquote className="text-white text-lg md:text-xl leading-relaxed mb-8 font-light">
                &ldquo;The pandabuy spreadsheet movement has transformed how fashion enthusiasts discover and compare products. What started as simple shared lists has evolved into a sophisticated curation ecosystem that saves hours of manual searching.&rdquo;
              </blockquote>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20stylish%20editor%20on%20warm%20terracotta%20backdrop%2C%20clean%20portrait%20photography%2C%20soft%20natural%20front%20lighting%2C%20minimalist%20editorial%20style%2C%20confident%20approachable%20expression&width=100&height=100&seq=editor-avatar-v2-025&orientation=squarish"
                    alt="Editor"
                    className="w-10 h-10 rounded-full object-cover border-2 border-white/30"
                  />
                  <div>
                    <p className="text-white text-sm font-medium">James Hart</p>
                    <p className="text-white/50 text-xs">Senior Curator</p>
                  </div>
                </div>
                <Link
                  to="/article/pandabuy-spreadsheet-beginners"
                  className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/15 text-white text-sm hover:bg-white/25 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Read Full Guide
                  <i className="ri-arrow-right-up-line"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}